import { GoogleOAuthProvider } from "@react-oauth/google";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { AuthGuard } from "./features/auth/components/AuthGuard";
import LoginPage from "./features/auth/pages/LoginPage";
import { ResetPasswordPage } from "./features/auth/pages/ResetPasswordPage";
import Analytics from "./features/mentor/pages/Analytics";
import { Appointments } from "./features/mentor/pages/Appointments";
import { Dashboard } from "./features/mentor/pages/Dashboard";
import { MenteesList } from "./features/mentor/pages/MenteesList";
import { MentorAvailability } from "./features/mentor/pages/MentorAvailability";
import { MentorCalendarConnect } from "./features/mentor/pages/MentorCalendarConnect";
import Messages from "./features/mentor/pages/Messages";
import { PostSession } from "./features/mentor/pages/PostSession";
import { PreSession } from "./features/mentor/pages/PreSession";
import Resources from "./features/mentor/pages/Resources";
import { Session } from "./features/mentor/pages/Session";
import VideoCall from "./features/mentor/pages/VideoCall";
import EmptyLayout from "./layouts/empty-layout";
import MainLayout from "./layouts/main-layout";

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route key="login" path="/auth/login" element={<LoginPage />} />
      <Route
        key="reset-password"
        path="/reset-password"
        element={<ResetPasswordPage />}
      />

      {/* Protected routes wrapper */}
      <Route element={<AuthGuard />}>
        {/* Default redirect */}
        <Route index element={<Navigate to="/mentor/dashboard" replace />} />

        {/* Mentor routes with Layout */}
        <Route
          path="mentor"
          element={
            <MainLayout>
              <Outlet />
            </MainLayout>
          }
        >
          <Route index element={<Navigate to="/mentor/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="mentees" element={<MenteesList />} />
          <Route path="appointments" element={<Appointments />} />
          <Route path="pre-session" element={<PreSession />} />
          <Route path="session" element={<Session />} />
          <Route path="post-session" element={<PostSession />} />
          <Route path="resources" element={<Resources />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="messages" element={<Messages />} />
          <Route
            path="calendar/connect"
            element={
              <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                <MentorCalendarConnect />
              </GoogleOAuthProvider>
            }
          />
          <Route
            path="calendar/availability"
            element={
              <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                <MentorAvailability />
              </GoogleOAuthProvider>
            }
          />
        </Route>

        <Route
          element={
            <EmptyLayout>
              <Outlet />
            </EmptyLayout>
          }
        >
          <Route path="mentor">
            <Route path="video-call" element={<VideoCall />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
